module.exports = __webpack_public_path__ + "img/logo2.881b9e4d.png";